export default __webpack_public_path__ + "static/datelabel-dropdown-do-2-dark-ee30c8d1028609cf184cbe090b4174d2d705c9e68a31c7ab92a620d06eb180eb.png";